export default __webpack_public_path__ + "static/media/cart-image.83a1d1c1.svg";